import * as React from 'react';
import { useEffect, useState } from 'react';
import { FormField, Input, Select, SpaceBetween } from '@amzn/awsui-components-react-v3';
import { isValidPrincipalNotRoot } from 'src/commons/validationUtils';

export interface LfPrincipalTypeSelectorProps {
  disableAccountLevelAccess: boolean;
  loading: boolean;
  principal: string;
  setPrincipal: any;
  isDWaaSWorkspace?: boolean;
}

export const LfPrincipalTypeSelector = (props: LfPrincipalTypeSelectorProps) => {
  const [principalErrorText, setPrincipalErrorText] = useState<string>(undefined);
  const [selectedPrincipalType, setSelectedPrincipalType] = useState<any>();
  const options =
    props.isDWaaSWorkspace || props.disableAccountLevelAccess
      ? [
          {
            label: 'IAM role/user access',
            value: 'iamRoleUserAccess',
            disabled: true,
          },
        ]
      : [
          {
            label: 'Workspace access (Entire account)',
            value: 'workspaceAccess',
          },
          {
            label: 'IAM role/user access',
            value: 'iamRoleUserAccess',
          },
        ];

  const validateIamPrincipal = (iamPrincipal: string) => {
    let errorText = !isValidPrincipalNotRoot(iamPrincipal) ? 'Invalid IAM principal ARN' : undefined;
    setPrincipalErrorText(errorText);
    return errorText === undefined;
  };

  useEffect(() => {
    if (!selectedPrincipalType) {
      setSelectedPrincipalType(options[0]);
    }
  }, []);

  return (
    <SpaceBetween size={'m'} direction={'vertical'}>
      <FormField label='Select Lake Formation access principal type'>
        <Select
          selectedOption={selectedPrincipalType}
          onChange={(e) => {
            setSelectedPrincipalType(e.detail.selectedOption);
          }}
          options={options}
          statusType={props.loading ? 'loading' : 'finished'}
          loadingText='Loading access options'
          data-testid={'select-permissions-principal-type'}
          disabled={props.isDWaaSWorkspace}
        />
      </FormField>
      {selectedPrincipalType?.value == 'iamRoleUserAccess' && (
        <FormField
          label='IAM User/Role'
          description='Enter the ARN for the IAM user or role'
          errorText={principalErrorText}
        >
          <Input
            ariaRequired={true}
            placeholder={'arn:aws:iam::123456789012:role/AWSDGSFoundry-ManagementRole-DO-NOT-DELETE'}
            value={props.principal}
            onChange={(e) => {
              validateIamPrincipal(e.detail.value);
              props.setPrincipal(e.detail.value);
            }}
            disabled={props.isDWaaSWorkspace}
          />
        </FormField>
      )}
    </SpaceBetween>
  );
};
